import React from "react";
import SelectDropDown from "./SelectDropDown";

const PAGE_SIZE_OPTIONS = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 50, label: "50" },
];

const Paginator = ({ currentPage, hasNextPage, onPrevPage, onNextPage, pageSize = 5, onPageSizeChange }) => {
  const selectedOption = PAGE_SIZE_OPTIONS.find((opt) => opt.value === pageSize);

  return (
    <div className="wantad-pagination">
      <div className="wantad-pagination-nav">
        <button
          className="wantad-pagination-btn"
          disabled={currentPage <= 1}
          onClick={onPrevPage}
        >
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 1L1 6L6 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Previous
        </button>
        <span className="wantad-pagination-page">Page {currentPage}</span>
        <button
          className="wantad-pagination-btn"
          disabled={!hasNextPage}
          onClick={onNextPage}
        >
          Next
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      {onPageSizeChange && (
        <div className="wantad-pagination-page-size">
          <span>Rows per page:</span>
          <SelectDropDown
            options={PAGE_SIZE_OPTIONS}
            value={selectedOption}
            onChange={(opt) => onPageSizeChange(opt.value)}
            className="wantad-pagination-select-dropdown"
            classNamePrefix="pagination-select"
            errorClass="d-none"
            menuPlacement="top"
          />
        </div>
      )}
    </div>
  );
};

export default Paginator;
